import { useMemo, useState } from 'react';
import React from 'react';
import PropTypes from 'prop-types';

import CustomTable from 'components/customTable';
import { importStatic, removeSpecialCharacter } from 'utils';

import SalaryPercentileTable from '../../../components/salaryPercentileTable';

const TitleSalaryPictureSection = ({ jobTitle, imageExist = true }) => {
  const [hide, setHide] = useState(!imageExist);
  const imageSrc = removeSpecialCharacter(jobTitle).toLowerCase();

  const hideImg = () => setHide(true);

  if (hide) return null;

  return (
    <div className="mt-68 w-635">
      <figure>
        <img
          src={importStatic(`/title-salary-images-webp/${imageSrc}-salary-2400x1350.webp`)}
          width={1200}
          height={675}
          className="img-fluid"
          alt={`Average ${jobTitle} Salary Graph`}
          title={`Average ${jobTitle} Salary Trends`}
          onError={hideImg}
        />
        <figcaption className="text-center text-muted small z-mt-3">
          {`Average ${jobTitle} Salary Graph, Trends, and Summary`}
        </figcaption>
      </figure>
    </div>
  );
};

export function SalaryByField({
  jobTitle,
  jobTitleArticle,
  imageExist,
  salariesForRelatedJobs = [],
  salaryPercentiles = [],
}) {
  const columnsConfig = {
    jobTitle: {
      columnName: 'Job Title',
      isLink: true,
      linkUrl: 'link',
      pageIndex: 'indexInfoOfJobsPage',
      linkTitle: 'jobTitleColLinkTitle',
    },
    salaryAnnual: {
      columnName: 'Annual Salary',
      customSortByField: 'salaryAnnualNo',
    },
    salaryMonthly: {
      columnName: 'Monthly Salary',
      customSortByField: 'monthlySalary',
    },
    hourlyRate: {
      columnName: 'Hourly Rate',
      customSortByField: 'hourlyRate',
    },
    jobCount: {
      columnName: 'Job Openings',
    },
  };

  const _salariesForRelatedJobs = useMemo(() => {
    return salariesForRelatedJobs.map((row) => {
      return {
        ...row,
        jobTitleColLinkTitle: `${row.jobTitle} Jobs`,
      };
    });
  }, [salariesForRelatedJobs]);

  return (
    <div id="by-field">
      <div className="d-flex flex-column flex-lg-row justify-content-lg-between">
        <div>
          <h2 className="brandonH2">{`${jobTitle} salary details`}</h2>
          <TitleSalaryPictureSection
            jobTitleArticle={jobTitleArticle}
            jobTitle={jobTitle}
            imageExist={imageExist}
          />

          {salaryPercentiles?.length && (
            <div className="mt-68 w-730 overflow-x-auto">
              <SalaryPercentileTable
                title={`What is ${jobTitleArticle} ${jobTitle?.toLowerCase?.()}'s salary?`}
                percentiles={salaryPercentiles}
              />
            </div>
          )}

          {!!salariesForRelatedJobs?.length && (
            <div className="mt-68 w-730 overflow-x-auto">
              <CustomTable
                columnConfig={columnsConfig}
                bodyData={_salariesForRelatedJobs}
                defaultRowsDisplay={20}
                tableHeaderTitleContent={
                  <h3 className="zp-title-h3 text-capitalize z-mb-24">{`Highest paying ${jobTitle?.toLowerCase?.()} jobs`}</h3>
                }
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

SalaryByField.propTypes = {
  jobTitle: PropTypes.string,
  jobTitleArticle: PropTypes.string,
  imageExist: PropTypes.bool,
  salariesForRelatedJobs: PropTypes.arrayOf(PropTypes.object),
};
